import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { base64 } from '@firebase/util';
import {
  AlertMsgService,
  App,
  AuthService,
  encryptPassword,
  ErrorMsg,
  UserHotel,
  SuccessfulRes,
  UserAPI
} from "@easyfo/common-lib"
import { CookieService } from "ngx-cookie-service";
import { environment } from "../../environments/environment";

@Injectable({ providedIn: 'root' })
export class UsersService {
  private errorMsgArr = ErrorMsg;
  alertMsg: string = '';
  base64textString: string = '';

  constructor(
    private userAPI: UserAPI,
    private recaptchaV3Service: ReCaptchaV3Service,
    private cookieService: CookieService,
    private authService: AuthService,
    private firebaseAuth: AngularFireAuth,
    private alertMsgService: AlertMsgService
  ) { }

  async loginFirebase(username: string, password: string) {
    try {
      const userCredential = await this.firebaseAuth.signInWithEmailAndPassword(username, password);
      if (!userCredential.user) throw new Error("User not found");
      return {
        success: true,
        user: userCredential.user
      }
    } catch (error: any) {
      this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
      return {
        success: false,
        error: error?.message,
      };
    }
  }

  async reloadAndGetUser(): Promise<User> {
    return new Promise((resolve, reject) => {
      this.firebaseAuth.authState.subscribe({
        next: async (res) => {
          if (!res) return reject();
          await res.reload();
          resolve(res);
        }, error: (err) => {
          reject();
        }
      });
    });
  }

  async sendVerificationEmail(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.firebaseAuth.authState.subscribe({
        next: async (res) => {
          if (!res) return resolve(false);
          try {
            await res.sendEmailVerification();
            resolve(true);
          } catch (err) {
            reject();
          }
        }, error: (err) => {
          reject();
        }
      });
    });
  }

  async requestLogin(username: string, password: string, isRememberMe: boolean) {
    return new Promise((resolve, reject) => {
      this.recaptchaV3Service.execute("user_login").subscribe({
        next: (token) => {
          let data: UserHotel.LoginRequestDTO = {
            username: username,
            password: encryptPassword(environment.backend.user.public_key, password)
          };
          // Past firebase authentication
          this.userAPI.requestLogin(token, data).subscribe({
            next: (response) => {
              if (response.success == true) {
                let expiredDate = new Date(response.expired);
                this.cookieService.set("authorized", base64.encodeString(response.token), { expires: expiredDate, path: '/', domain: location.hostname });
                this.cookieService.set("uid", base64.encodeString(response.data.user_id), { expires: expiredDate, path: '/', domain: location.hostname });
                this.cookieService.set("fname", base64.encodeString(response.data.firstname), { expires: expiredDate, path: '/', domain: location.hostname });
                if (response.data.middlename) {
                  this.cookieService.set("mname", base64.encodeString(response.data.middlename), { expires: expiredDate, path: '/', domain: location.hostname });
                }
                this.cookieService.set("lname", base64.encodeString(response.data.lastname), { expires: expiredDate, path: '/', domain: location.hostname });
                this.cookieService.set("language", base64.encodeString(response.data.language), { expires: expiredDate, path: '/', domain: location.hostname });
                // Checked remember me
                if (!isRememberMe) {
                  this.cookieService.set("expired", base64.encodeString(response.expired), { expires: expiredDate, path: '/', domain: location.hostname });
                }

                // Call getUserProfileApi
                let jwt = base64.decodeString(this.cookieService.get("authorized"), false);
                this.userAPI.requestUserProfileImg(jwt).subscribe({
                  next: (res) => { localStorage.setItem("uimg", JSON.stringify(res)); }
                  , error: (err: any) => { }
                });
                resolve(true);
              } else {
                this.cookieService.delete("authorized", '/', location.hostname);
                this.cookieService.delete("name", '/', location.hostname);
                this.cookieService.delete("language", '/', location.hostname);
                resolve(false);
              }
            }, error: (error: any) => {
              this.firebaseAuth.signOut();
              this.cookieService.delete("authorized", '/', location.hostname);
              this.cookieService.delete("name", '/', location.hostname);
              this.cookieService.delete("language", '/', location.hostname);
              this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
              reject();
            }
          });
        }, error: (error) => {
          this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
          throw (error);
        }
      });
    });
  }

  // requestLogin(username: string, password: string, isRememberMe: boolean, callback: any) {
  //   this.recaptchaV3Service.execute("user_login").subscribe({
  //     next: (token) => {
  //       let data: UserHotel.LoginRequestDTO = {
  //         username: username,
  //         password: encryptPassword(environment.backend.user.public_key, password)
  //       };

  //       this.firebaseAuth.signInWithEmailAndPassword(username, password).then((result) => {
  //         // Not activation email link yet
  //         if (!result.user!.emailVerified) throw new Error("auth/email-not-verified");

  //         // Past firebase authentication
  //         this.userAPI.requestLogin(token, data).subscribe({
  //           next: (response) => {
  //             if (response.success == true) {
  //               let expiredDate = new Date(response.expired);
  //               this.cookieService.set("authorized", base64.encodeString(response.token), { expires: expiredDate, path: '/', domain: location.hostname });
  //               this.cookieService.set("uid", base64.encodeString(response.data.user_id), { expires: expiredDate, path: '/', domain: location.hostname });
  //               this.cookieService.set("fname", base64.encodeString(response.data.firstname), { expires: expiredDate, path: '/', domain: location.hostname });
  //               if (response.data.middlename) {
  //                 this.cookieService.set("mname", base64.encodeString(response.data.middlename), { expires: expiredDate, path: '/', domain: location.hostname });
  //               }
  //               this.cookieService.set("lname", base64.encodeString(response.data.lastname), { expires: expiredDate, path: '/', domain: location.hostname });
  //               this.cookieService.set("language", base64.encodeString(response.data.language), { expires: expiredDate, path: '/', domain: location.hostname });
  //               // Checked remember me
  //               if (!isRememberMe) {
  //                 this.cookieService.set("expired", base64.encodeString(response.expired), { expires: expiredDate, path: '/', domain: location.hostname });
  //               }

  //               // Call getUserProfileApi
  //               let jwt = base64.decodeString(this.cookieService.get("authorized"), false);
  //               this.userAPI.requestUserProfileImg(jwt)
  //                 .subscribe((res) => {
  //                   localStorage.setItem("uimg", JSON.stringify(res));
  //                 }, (error) => { });
  //               callback(true);
  //             } else {
  //               this.cookieService.delete("authorized", '/', location.hostname);
  //               this.cookieService.delete("name", '/', location.hostname);
  //               this.cookieService.delete("language", '/', location.hostname);
  //               callback(false);
  //             }
  //           }, error: (error: any) => {
  //             this.firebaseAuth.signOut();
  //             this.cookieService.delete("authorized", '/', location.hostname);
  //             this.cookieService.delete("name", '/', location.hostname);
  //             this.cookieService.delete("language", '/', location.hostname);
  //             this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
  //             callback(false);
  //           }
  //         });
  //       }).catch((error) => {
  //         this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_FIREBASE);
  //         callback(false);
  //       });
  //     }, error: (error) => {
  //       this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
  //       callback(false);
  //     }
  //   });
  // }

  requestLanding(callback: (result: UserHotel.HotelResponseDTO[] | undefined) => void) {
    if (!callback) return;
    let jwt = base64.decodeString(this.cookieService.get("authorized"), false);
    this.userAPI.requestLanding(jwt).subscribe({
      next: (response) => {
        callback(response.hotels);
      }, error: (error) => {
        if (this.authService.handleSessionExpired(error) == true) {
          return;
        } else if (error && "107" == error.code) {
          return;
        } else {
          callback(undefined);
        }
      }
    });
  }

  requestRegister(username: string, password: string, firstname: string, middlename: string, lastname: string, language: string, callback: (response: UserHotel.RegisterResponseDTO) => void) {
    if (!callback) return;
    this.recaptchaV3Service.execute("user_register").subscribe((token) => {
      this.firebaseAuth.createUserWithEmailAndPassword(username, password)
        .then((result) => {
          let data: UserHotel.RegisterRequestDTO = {
            username: username,
            password: encryptPassword(environment.backend.user.public_key, password),
            firstname: firstname,
            middlename: middlename,
            lastname: lastname,
            language: language,
            uid: result.user?.uid!,
          };

          this.userAPI.requestRegister(token, data).subscribe({
            next: (response) => {
              if (response) {
                result.user?.sendEmailVerification().then(() => {
                  this.alertMsg = this.alertMsgService.handleDisplayAlert(SuccessfulRes.CREATE, App.ALERT_MSG_REGISTER);
                  callback(response);
                });
              }
            },
            error: (error) => {
              // Delete user in firebase
              result.user?.delete();
              this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
              callback(error);
            }
          });
        })
        .catch((error) => {
          this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_FIREBASE);
          callback(error);
        });
    });
  }

  isLogin(): boolean {
    return Boolean(this.authService.isLogin());
  }

  async applyHotelSelected(hotelId: string, hotelDetail: UserHotel.HotelResponseDTO) {
    let expired = base64.decodeString(this.cookieService.get("expired"), false);
    let expiredDate = new Date(expired);
    this.cookieService.set("hid", base64.encodeString(hotelId), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hname", base64.encodeString(hotelDetail.name), { expires: expiredDate, path: '/', domain: location.hostname });

    this.cookieService.set("hrm", base64.encodeString(JSON.stringify(hotelDetail.rights.main_menu)), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hrc", base64.encodeString(JSON.stringify(hotelDetail.rights.cashier)), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hrf", base64.encodeString(JSON.stringify(hotelDetail.rights.front_desk)), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hrfn", base64.encodeString(JSON.stringify(hotelDetail.rights.function)), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hrh", base64.encodeString(JSON.stringify(hotelDetail.rights.housekeeping)), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hrp", base64.encodeString(JSON.stringify(hotelDetail.rights.profile)), { expires: expiredDate, path: '/', domain: location.hostname });
    this.cookieService.set("hrs", base64.encodeString(JSON.stringify(hotelDetail.rights.setup)), { expires: expiredDate, path: '/', domain: location.hostname });
  }

  applyHotelSidebar(numberHotels: Number) {
    let expired = base64.decodeString(this.cookieService.get("expired"), false);
    let expiredDate = new Date(expired);
    this.cookieService.set("nHotels", btoa(numberHotels.toString()), { expires: expiredDate, path: '/', domain: location.hostname });
  }

  handleDisplayError(errorResponse: any) {
    let displayErrorMsg!: string;

    if (errorResponse.hasOwnProperty("error")) {
      this.errorMsgArr.some((el) => {
        if (el.code !== errorResponse.error.code) {
          displayErrorMsg = "Server Error, please try again later";
          return;
        }
      });

      // Error from API
      this.errorMsgArr.forEach((el) => {
        if (errorResponse.error.code === el.code) {
          displayErrorMsg = el.message;
          return;
        }
      });
    } else {
      // Time out
      displayErrorMsg =
        "Looks like the server is taking to long to respond. Please try again later";
    }
    return displayErrorMsg;
  }

  checkEmptyValue(...args: (string | undefined)[]) {
    let valueOfArgs: boolean[] = [];
    args.forEach((el) =>
      // If have value push true IF NOT push false
      el ? valueOfArgs.push(true) : valueOfArgs.push(false)
    );
    /**
     * False = NOT have value
     * True = HAVE value
     */
    return valueOfArgs.includes(false) ? false : true;
  }

  handleFileSelect(evt: any) {
    var files = evt;
    var file = files[0];

    if (files && file) {
      var reader = new FileReader();

      reader.onload = this._handleReaderLoaded.bind(this);

      reader.readAsBinaryString(file);
    }
  }

  _handleReaderLoaded(readerEvt: any) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
  }

  requestLandingSelectHotel(hotelId: string): Promise<UserHotel.HotelResponseDTO[]> {
    return new Promise((resolve, reject) => {
      const jwt = base64.decodeString(this.cookieService.get('authorized'), false);
      this.userAPI.requestLandingSelectHotel(jwt, hotelId).subscribe({
        next: (response) => {
          if (response.success) resolve(response.hotels);
          else {
            this.alertMsg = this.alertMsgService.handleDisplayAlert(response, App.ALERT_MSG_GLOBAL);
            resolve([]);
          };
        }, error: (error) => {
          this.alertMsg = this.alertMsgService.handleDisplayAlert(error, App.ALERT_MSG_GLOBAL);
          reject(error);
        }
      });
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      const jwt = base64.decodeString(this.cookieService.get('authorized'), false);
      this.recaptchaV3Service.execute('user_logout').subscribe((token) => {
        this.userAPI.requestLogout(token, jwt).subscribe({
          next: (response) => {
            this.clearCookie();
            this.firebaseAuth.signOut();
            resolve(true);
          }, error: (error) => {
            this.clearCookie();
            reject();
          }
        });
      });
    });
  }

  async logoutFirebase() {
    try {
      await this.firebaseAuth.signOut();
    } catch (error) {

    }
  }

  clearCookie() {
    // this.cookieService.deleteAll();
    this.cookieService.delete('authorized', '/', location.hostname);
    this.cookieService.delete('fname', '/', location.hostname);
    this.cookieService.delete('mname', '/', location.hostname);
    this.cookieService.delete('lname', '/', location.hostname);
    this.cookieService.delete('name', '/', location.hostname);
    this.cookieService.delete('hid', '/', location.hostname);
    this.cookieService.delete('hname', '/', location.hostname);
    this.cookieService.delete('expired', '/', location.hostname);
    this.cookieService.delete('language', '/', location.hostname);
    this.cookieService.delete('sdate', '/', location.hostname);
    this.cookieService.delete('vat', '/', location.hostname);

    localStorage.removeItem('uimg');
    localStorage.removeItem('bimg');
    localStorage.removeItem('_grecaptcha');
  }
}

interface User {
  displayName: string | null;
  email: string | null;
  phoneNumber: string | null;
  photoURL: string | null;
  providerId: string;
  uid: string;

  emailVerified: boolean;
  isAnonymous: boolean;
  refreshToken: string;
  tenantId: string | null;
  delete(): Promise<void>;
  getIdToken(forceRefresh?: boolean): Promise<string>;
  reload(): Promise<void>;
}